import cx from 'classnames';
import { ButtonHTMLAttributes } from 'react';
import { FormattedMessage as T } from 'react-intl';
import m from '../../components/Translations/messages';

import Spinner from '../../components/LoadingScreens/Spinner';

type ButtonProps = {
  loading?: boolean;
  className?: string;
  variant?: 'blue' | 'peach';
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({
  loading,
  children,
  variant = 'peach',
  disabled,
  className,
  ...props
}: ButtonProps) => {
  const notInteractive = loading || disabled;

  let cursor = 'cursor-pointer';
  if (disabled) {
    cursor = 'cursor-not-allowed';
  } else if (loading) {
    cursor = 'cursor-wait';
  }

  return (
    <button
      type="button"
      className={cx(
        'relative w-fit rounded-md px-6 py-3 text-base font-medium ring-digital ring-offset-2 outline-hidden transition-all focus:ring-2 disabled:bg-grey-10 disabled:text-muted',
        variant === 'blue' &&
          'bg-blue-50 text-white hover:bg-blue-60 active:bg-blue-70',
        variant === 'peach' &&
          'bg-peach-50 text-grey-90 hover:bg-peach-60 active:bg-peach-70',
        cursor,
        className,
      )}
      disabled={notInteractive}
      {...props}
    >
      <span
        className={cx('transition-all', loading ? 'opacity-0' : 'opacity-100')}
      >
        {children}
      </span>
      {loading && (
        <div className="absolute inset-0 flex place-content-center">
          <Spinner className="mt-0.5" size="w-5" color="text-heading" />
          <span aria-hidden="true" className="sr-only">
            <T {...m.wordLoading} />
          </span>
        </div>
      )}
    </button>
  );
};

export default Button;
